// state argument is not application state

export default function(state = {}, action) {
	switch (action.type) {
		case "PHOTO_SELECTED":
			return action.payload;
		default:
			return state;
	}
} 